export { default as banner } from './banner.png';
export { default as banner_VN } from './banner_VN.png';
export { default as banner_mobile } from './banner_mobile.png';
export { default as banner_mobile_VN } from './banner_mobile_VN.png';
